import { useCallback, useEffect, useState } from 'react'

import {
  DEFAULT_NOISE_FILTER_MODE,
  loadNoiseFilterMode,
  type NoiseFilterMode,
  normalizeNoiseFilterMode,
  saveNoiseFilterMode,
} from '@/src/lib/noiseFilter'

/**
 * Хранит выбранный режим шумодава в React-состоянии и localStorage.
 *
 * Подписка на `storage` синхронизирует PreJoin и in-call без отдельного Context.
 */
export function useNoiseFilterMode() {
  const [mode, setModeState] = useState<NoiseFilterMode>(DEFAULT_NOISE_FILTER_MODE)

  useEffect(() => {
    setModeState(loadNoiseFilterMode())

    const syncFromStorage = () => {
      setModeState(loadNoiseFilterMode())
    }

    window.addEventListener('storage', syncFromStorage)

    return () => {
      window.removeEventListener('storage', syncFromStorage)
    }
  }, [])

  const setMode = useCallback((next: NoiseFilterMode) => {
    const saved = saveNoiseFilterMode(normalizeNoiseFilterMode(next))
    setModeState(saved)
    return saved
  }, [])

  return { mode, setMode }
}
